export default __webpack_public_path__ + "static/media/IMG_1981.5f2ac0cf.jpg";